/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plain_Text_Import_Select_File_LabelInputs */

const en_plain_text_import_select_file_label = /** @type {(inputs: Plain_Text_Import_Select_File_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select Transcript File`)
};

const fr_plain_text_import_select_file_label = /** @type {(inputs: Plain_Text_Import_Select_File_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selectionner le fichier de transcription`)
};

const de_plain_text_import_select_file_label = /** @type {(inputs: Plain_Text_Import_Select_File_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transkriptdatei auswählen`)
};

const it_plain_text_import_select_file_label = /** @type {(inputs: Plain_Text_Import_Select_File_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona il file di trascrizione`)
};

const ru_plain_text_import_select_file_label = /** @type {(inputs: Plain_Text_Import_Select_File_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите файл стенограммы`)
};

const es_plain_text_import_select_file_label = /** @type {(inputs: Plain_Text_Import_Select_File_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccionar archivo de transcripción`)
};

const zh_cn2_plain_text_import_select_file_label = /** @type {(inputs: Plain_Text_Import_Select_File_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择成绩单文件`)
};

const ja_plain_text_import_select_file_label = /** @type {(inputs: Plain_Text_Import_Select_File_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`トランスクリプトファイルを選択`)
};

const hi_plain_text_import_select_file_label = /** @type {(inputs: Plain_Text_Import_Select_File_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रतिलेख फ़ाइल का चयन करें`)
};

const pt_pt2_plain_text_import_select_file_label = /** @type {(inputs: Plain_Text_Import_Select_File_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione o arquivo de transcrição`)
};

/**
* | output |
* | --- |
* | "Select Transcript File" |
*
* @param {Plain_Text_Import_Select_File_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const plain_text_import_select_file_label = /** @type {((inputs?: Plain_Text_Import_Select_File_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plain_Text_Import_Select_File_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_plain_text_import_select_file_label(inputs)
	if (locale === "de") return de_plain_text_import_select_file_label(inputs)
	if (locale === "it") return it_plain_text_import_select_file_label(inputs)
	if (locale === "ru") return ru_plain_text_import_select_file_label(inputs)
	if (locale === "es") return es_plain_text_import_select_file_label(inputs)
	if (locale === "zh-CN") return zh_cn2_plain_text_import_select_file_label(inputs)
	if (locale === "ja") return ja_plain_text_import_select_file_label(inputs)
	if (locale === "hi") return hi_plain_text_import_select_file_label(inputs)
	if (locale === "pt-PT") return pt_pt2_plain_text_import_select_file_label(inputs)
	return en_plain_text_import_select_file_label(inputs)
});